/**
 * useClaimHistory — fetches claim history from the creator fees API.
 *
 * Extracts the history array from CreatorFeesResponse.
 * Backed by IClankerIndexerService (indexed data, not direct chain reads).
 *
 * Story 6.3 — Task 3
 */

import { useCreatorFees } from "./use-creator-fees";

export function useClaimHistory(tokenId: string) {
	const { data, isLoading, error } = useCreatorFees(tokenId);

	return {
		history: data?.history ?? [],
		accumulated: data?.accumulated ?? null,
		meta: data?.meta ?? null,
		isLoading,
		error,
	};
}
